import { Injectable } from '@angular/core';


@Injectable({providedIn: 'root'})
export class SettingsValuesService {


  private _SettingsService: any = {};
  private _isInitialized = false;

  public set SettingsService(value: any) {
    this._isInitialized = true;
    this._SettingsService = value;
  }
  public get SettingsService() {
    return this._SettingsService;
  }

  public get isInitialized() {
    return this._isInitialized;
  }

  // Inactivity Timeout in seconds
  public get $inactivityTimeout() {
    return this._SettingsService.$inactivityTimeout;
  }

  public get DateFormat() {
    return this._SettingsService['DateFormat'];
  }
  public get FootPrintAPI() {
    return this._SettingsService['FootPrintAPI'];
  }
  public get FootprintSftp() {
    return this._SettingsService['FootprintSftp'];
  }
  public get MongoDB() {
    return this._SettingsService['MongoDB'];
  }
  public get RabbitMQ() {
    return this._SettingsService['RabbitMQ'];
  }
  public get TimeFormat() {
    return this._SettingsService['TimeFormat'];
  }

  public app: SettingsValuesService = this;

  public get FootprintEdi() {
     return {
DateFormat : this.DateFormat,
FootprintApi : this.FootPrintAPI,
FootprintApi_ReadOnly : this.FootPrintAPI,
MongoDb : this.MongoDB,
RabbitMQ : this.RabbitMQ,
TimeFormat : this.TimeFormat
    };
  }
  public get Utilities() {
     return {
FootprintApi : this.FootPrintAPI,
MongoDb : this.MongoDB
    };
  }
  public get Notifications() {
     return {
FootprintApi : this.FootPrintAPI,
MongoDb : this.MongoDB
    };
  }
  public get FootprintApiManager() {
     return {
DateFormat : this.DateFormat,
FootprintApi : this.FootPrintAPI,
FootprintApi_ReadOnly : this.FootPrintAPI,
MongoDb : this.MongoDB,
TimeFormat : this.TimeFormat
    };
  }
  public get Attachments() {
     return {
FootprintApi : this.FootPrintAPI,
MongoDb : this.MongoDB
    };
  }
  public get Instructions() {
     return {
FootprintApi : this.FootPrintAPI,
MongoDb : this.MongoDB
    };
  }
  public get Inventory() {
     return {
FootprintApi : this.FootPrintAPI,
MongoDb : this.MongoDB
    };
  }
  public get Materials() {
     return {
FootprintApi : this.FootPrintAPI,
MongoDb : this.MongoDB
    };
  }
  public get SerialNumbers() {
     return {
FootprintApi : this.FootPrintAPI,
MongoDb : this.MongoDB
    };
  }
  public get DockAppointments() {
     return {
DateFormat : this.DateFormat,
FootprintApi : this.FootPrintAPI,
MongoDb : this.MongoDB,
TimeFormat : this.TimeFormat
    };
  }
  public get Owners() {
     return {
FootprintApi : this.FootPrintAPI,
MongoDb : this.MongoDB
    };
  }
  public get Addresses() {
     return {
FootprintApi : this.FootPrintAPI,
FootprintApi_ReadOnly : this.FootPrintAPI,
MongoDb : this.MongoDB
    };
  }
  public get Lots() {
     return {
FootprintApi : this.FootPrintAPI,
MongoDb : this.MongoDB
    };
  }
  public get Carriers() {
     return {
FootprintApi : this.FootPrintAPI,
MongoDb : this.MongoDB
    };
  }
  public get PurchaseOrders() {
     return {
FootprintApi : this.FootPrintAPI,
FootprintApi_ReadOnly : this.FootPrintAPI,
MongoDb : this.MongoDB
    };
  }
  public get SalesOrders() {
     return {
FootprintApi : this.FootPrintAPI,
MongoDb : this.MongoDB
    };
  }
  public get AsnOrders() {
     return {
FootprintApi : this.FootPrintAPI,
FootprintApi_ReadOnly : this.FootPrintAPI,
MongoDb : this.MongoDB
    };
  }
  public get FootprintTestUtilities() {
     return {
FootprintApi : this.FootPrintAPI,
MongoDb : this.MongoDB
    };
  }
  public get Cartonization() {
     return {
FootprintApi : this.FootPrintAPI,
MongoDb : this.MongoDB
    };
  }
}
